import { render, staticRenderFns } from "./AppEventsList.vue?vue&type=template&id=1b9e8cd9&scoped=true&"
import script from "./AppEventsList.vue?vue&type=script&lang=js&"
export * from "./AppEventsList.vue?vue&type=script&lang=js&"
import style0 from "./AppEventsList.vue?vue&type=style&index=0&id=1b9e8cd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9e8cd9",
  null
  
)

export default component.exports